import { DateTime } from "luxon";
import type { PropsWithChildren } from "react";

import Tooltip from "@mui/material/Tooltip";

type RelativeDateProps = PropsWithChildren<{
  timestamp: string; // iso string
}>;
export const RelativeDate = ({ timestamp }: RelativeDateProps) => {
  if (!timestamp) {
    return <></>;
  }

  return (
    <Tooltip title={DateTime.fromISO(timestamp).toLocaleString()}>
      <div>{DateTime.fromISO(timestamp).toRelative()}</div>
    </Tooltip>
  );
};
